import { useTranslation } from 'react-i18next';

import type {
  PortalRenewReadinessState,
  PortalUpgradeReadinessState,
} from '@/modules/portal/utils/portalSelfServiceHelpers';
import { cn } from '@/shared/lib/cn';

type ReadinessState = PortalRenewReadinessState | PortalUpgradeReadinessState;

const toneByState: Record<ReadinessState, string> = {
  no_subscription: 'bg-muted text-muted-foreground',
  payment_attention: 'bg-amber-500/15 text-amber-800 dark:text-amber-400',
  subscription_ended: 'bg-red-500/15 text-red-700 dark:text-red-400',
  access_restricted: 'bg-amber-500/15 text-amber-800 dark:text-amber-400',
  self_service_preparing: 'bg-sky-500/15 text-sky-800 dark:text-sky-400',
};

interface PortalReadinessBadgeProps {
  namespace: 'renew' | 'upgrade';
  state: ReadinessState;
}

export function PortalReadinessBadge({ namespace, state }: PortalReadinessBadgeProps) {
  const { t } = useTranslation();
  const label = t(`portal.${namespace}.readiness.${state}`);
  const hint = t(`portal.${namespace}.readinessHint.${state}`, { defaultValue: '' });

  return (
    <span className="inline-flex flex-col gap-1">
      <span
        className={cn(
          'inline-flex w-fit items-center rounded-full px-3 py-1 text-sm font-medium',
          toneByState[state],
        )}
      >
        {label}
      </span>
      {hint ? <span className="text-xs text-muted-foreground">{hint}</span> : null}
    </span>
  );
}
